
import CompoundCategoryEditComponent from "../../../components/compound_categories/Edit.vue";

export default {
  components: {
    CompoundCategoryEditComponent
  }
}
